import $ from "jquery";
import {useEffect, useState} from "react";
import { Modal, Button, Form } from "react-bootstrap";
import "../styles/css/admin-style.css"
import {userService} from "../services/userService";
import NotificationService from "../services/NotificationService";
import FormControl from "../shared/components/FormControl";

interface EditOwnProfileModalProps {
    show: boolean;
    toggle: () => void;
    user: {firstName: string, lastName: string, email: string, userId: string}
    refreshData: () => void;
}

const EditOwnProfileModal: React.FC<EditOwnProfileModalProps> = ({ show, toggle, user, refreshData}) => {
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [email, setEmail] = useState("");
    const [isActive, setIsActive] = useState(true);
    const [userId, setUserId] = useState("");
    const [showErrors, setShowErrors] = useState(false);

    const handleSave = () => {
        if (!firstName || !lastName || !email) {
            setShowErrors(true);
            return;
        }
        Promise.resolve(
            userService.updateUser(userId, firstName, lastName, email, !isActive)
        ).then(postRes => {
            if(postRes === undefined)
                return;
            refreshData();
            toggle();
            return postRes;
        });
    };

    useEffect(() => {
        if(!user) return;
        setUserId(user.userId)
        setFirstName(user.firstName)
        setLastName(user.lastName)
        setEmail(user.email)
    }, [user]);

    return (
        <Modal show={show} onHide={toggle}>
            <Modal.Header closeButton>
                <h5 className="modal-title" id="profileModalTitle">My Info</h5>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <div className="row gx-3">
                        <Form.Group controlId="userFirstName" className="col-md-6 mb-3">
                            <FormControl
                                showErrors={showErrors}
                                type="text"
                                label="First Name"
                                placeholder="First Name"
                                value={firstName}
                                onChange={(e) => setFirstName(e.target.value)}
                                required
                            />
                        </Form.Group>
                        <Form.Group controlId="userLastName" className="col-md-6 mb-3">
                            <FormControl
                                label="Last Name"
                                showErrors={showErrors}
                                type="text"
                                placeholder="Last Name"
                                value={lastName}
                                onChange={(e) => setLastName(e.target.value)}
                                required
                            />
                        </Form.Group>
                    </div>
                    <div className="row gx-3">
                        <Form.Group controlId="userEmail" className="mb-3">
                            <FormControl
                                type="email"
                                label={"Email Address"}
                                placeholder="Email Address"
                                value={email}
                                showErrors={showErrors}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                            />
                        </Form.Group>
                    </div>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button className="btn btn-primary text-strong text-uppercase m-100" onClick={handleSave}>
                    Save
                </Button>
                <Button className="btn btn-cancel text-strong text-uppercase m-100" onClick={toggle}>
                    Cancel
                </Button>
            </Modal.Footer>
        </Modal>
    );
};
export default EditOwnProfileModal;


